import type { IAddress } from '@bridebook/models/source/models/Weddings.types';
import type { IUISupplier } from '@bridebook/toolbox/src/types';
import { AutocompleteItem } from '@bridebook/web/app-shared/lib/search/types';

export function extractLocationName(location: IAddress | null): string {
  if (!location) {
    return '';
  }
  let weddingLocation = location.name || '';
  const isStreetName = Array.isArray(location.street) && location.street.includes(weddingLocation);
  if (isStreetName || location.postalCode === weddingLocation) {
    weddingLocation = `${weddingLocation} ${location.city || ''}`;
  }
  return weddingLocation.trim();
}

export const isSupplier = (item: AutocompleteItem): item is IUISupplier =>
  'id' in item && 'name' in item && !('place_id' in item);
